export default {
	'topBar.issuesHistory': 'Problemverlauf',
	'topBar.projectManagement': 'Projekte',
	'topBar.typeToSearch': 'Suchen...',
	'topBar.findPages': 'Finden...',
	'topBar.actions': 'Aktionen',
	'topBar.status': 'Status',
	'topBar.profileMenu.hello': 'Hallo',
	'topBar.profileMenu.activeUser': 'Angemeldet als',
	'topBar.profileMenu.billingPlan': 'Zahlungsplan',
	'topBar.profileMenu.role': 'Rolle',
	'topBar.profileMenu.email': 'E-Mail',
	'topBar.profileMenu.phone': 'Telefon',
	'topBar.profileMenu.editProfile': 'Profil anpassen',

	'admin.management': 'Übersicht',
	'admin.role': 'Rolle',
	'admin.roles': 'Rollen',

	'actions.accept': 'Übernehmen',
	'actions.add': 'Hinzufügen',
	'actions.back': 'Zurück',
	'actions.begin': 'Beginnen',
	'actions.cancel': 'Abbrechen',
	'actions.close': 'Schließen',
	'actions.continue': 'Fortsetzen',
	'actions.create': 'Erstellen',
	'actions.delete': 'Löschen',
	'actions.download': 'Download',
	'actions.edit': 'Bearbeiten',
	'actions.edit.item': '{{ item }} bearbeiten',
	'actions.export': '„{{ name }}“ für {{ num }} Teilnehmer exportieren',
	'actions.exportAll': '„{{ name }}“ für alle Teilnehmer exportieren',
	'actions.exportOne': '„{{ name }}“ exportieren',
	'actions.hide': 'Verstecken',
	'actions.lock_screen': 'Bildschirm sperren',
	'actions.login': 'Anmelden',
	'actions.logout': 'Abmelden',
	'actions.manage': 'Verwalten',
	'actions.new.participant': 'Neuer Teilnehmer',
	'actions.new.project': 'Neues Projekt',
	'actions.new.user': 'Neuer Benutzer',
	'actions.next': 'Weiter',
	'actions.next_question_group': 'Nächster Test',
	'actions.OK': 'OK',
	'actions.open': 'Öffnen',
	'actions.openAs': 'Öffnen Als',
	'actions.print': '{{ name }} drucken',
	'actions.randomization.start': 'Randomisierung ausführen',
	'actions.randomization.reset': 'Randomisierung wiederrufen',
	'actions.restart': 'Neu Starten',
	'actions.save': 'Speichern',
	'actions.select': '{{ selectItem }} auswählen',
	'actions.show': 'Anzeigen',
	'actions.show_participant_detail': 'zu Teilnehmerdetails',
	'actions.show_participant_overview': 'zur Teilnehmerübersicht',
	'actions.show_participant_overview_search': 'zur Teilnehmersuche',
	'actions.deselect_participant': 'Teilnehmer abwählen',
	'actions.show_user_detail': 'zu Benutzerdetails',
	'actions.show_workflow': 'zur Übersicht',
	'actions.skip_question_group': 'Test überspringen',
	'actions.start': 'Starten',
	'actions.restartTest': 'Test neu starten',
	'actions.starttest': 'Test Starten',
	'actions.stop': 'Stop',
	'actions.searchFor': '{{ searchItem }} suchen',
	'actions.goToTest': 'Zum Test',

	'btn.privacy_protection': 'Erweiterter Datenschutz',

	'datePicker.week': 'Woche',
	'datePicker.calendar': 'Kalender',
	'datePicker.clear': 'Leeren',
	'datePicker.today': 'Heute',
	'datePicker.month.january': 'Januar',
	'datePicker.month.february': 'Februar',
	'datePicker.month.march': 'März',
	'datePicker.month.april': 'April',
	'datePicker.month.may': 'Mai',
	'datePicker.month.june': 'Juni',
	'datePicker.month.july': 'Juli',
	'datePicker.month.august': 'August',
	'datePicker.month.september': 'September',
	'datePicker.month.october': 'Oktober',
	'datePicker.month.november': 'November',
	'datePicker.month.december': 'Dezember',
	'datePicker.day.monday': 'Montag',
	'datePicker.day.monday.short': 'Mo',
	'datePicker.day.tuesday': 'Dienstag',
	'datePicker.day.tuesday.short': 'Di',
	'datePicker.day.wednesday': 'Mittwoch',
	'datePicker.day.wednesday.short': 'Mi',
	'datePicker.day.thursday': 'Donnerstag',
	'datePicker.day.thursday.short': 'Do',
	'datePicker.day.friday': 'Freitag',
	'datePicker.day.friday.short': 'Fr',
	'datePicker.day.saturday': 'Samstag',
	'datePicker.day.saturday.short': 'Sa',
	'datePicker.day.sunday': 'Sonntag',
	'datePicker.day.sunday.short': 'So',
	'datePicker.format': 'dd.MM.yyyy',

	'device.override': 'Hardware überschreiben',
	'device.TouchScreen': 'Touch Screen',
	'device.ButtonDevice': 'Vita React',
	'device.TappingPen': 'Vita Pen',
	'device.ExternalAudiometry': 'Externes Audiometer',
	'device.Audiometry_Sh_HDA_300__Sb_X_FI_HD': 'Audiometrie - Sennheiser HDA 300 + SB X-Fi HD',
	'device.Audiometry_Sh_HDA_300__Sb_X_G1__Th_PS_TPY_2003_KBB': 'Audiometrie - Sennheiser HDA 300 + SB X G1 + Thomann pro snake TPY 2003 KBB Adapter',
	'device.Audiometry_bd_DT_770_PRO_80__Sb_X_FI_HD': 'Audiometrie - beyerdynamic DT-770 Pro/80 + SB X-Fi HD',
	'device.Audiometry_bd_DT_770_PRO_32__Sb_X_G1': 'Audiometry - beyerdynamic DT-770 Pro/32 + SB X G1',
	'device.TestHardware': 'Test-Hardware',
	'device.ExternalBicycleErgometer': 'Fahrradergometer (extern)',
	'device.SoundDevice': 'Sound-Ausgabe',
	'device.CalibratedHeadphones': 'Kalibrierter Kopfhörer',

	'export.modal.title': 'Bitte wählen Sie die Tabellen aus, die Sie exportieren möchten.',
	'export.label': 'Tabellenname',
	
	'form.input.minlength': 'Es müssen mindestens {{ requiredLength }} Zeichen eingegeben werden (bisher {{actualLength}}).',
	'form.input.required': '{{ itemName }} benötigt Eingabe.',
	'form.submit.assign': 'Zuordnen',

	'health.age': 'Alter',
	'health.age_bio': 'Biologische Alter',
	'health.weight': 'Gewicht',

	'input.string.error.length.minMax': 'Die Länge der Eingabe muss zwischen {{ minLength }} und {{ maxLength }} Zeichen liegen.',
	'input.string.error.length.max': 'Die Länge der Eingabe darf nicht mehr als {{ maxLength }} Zeichen haben.',
	'input.string.error.length.min': 'Die Länge der Eingabe muss mindestens {{ minLength }} Zeichen betragen',
	'input.string.error.required': 'Eingabe benötigt',
	'input.string.error.length.unknownError': 'Fehlerhafte Eingabe.',

	'message.confirm.randomization.reset': 'Sind Sie sicher, dass Sie die Randomisierungseinteilung für den Teilnehmer entfernen möchten?',
	'message.confirm.randomization.start': 'Sind Sie sicher, dass Sie die Randomisierung starten wollen? Dieser Schritt ist unwiderruflich.',
	'message.info.projectrole.notassigned': 'Der Nutzer ist dem Projekt nicht zugeordnet.',
	'message.info.projectrole.notpermitted': 'Mit Ihren derzeitigen Berechtigungen können Sie die Rollenzuweisung nicht ändern.',
	'message.warning.participant.noneLoaded.description': 'Kein Teilnehmer wurde ausgewählt um diesen Workflow zu bearbeiten.',
	'message.warning.participant.noneLoaded.title': 'Kein Teilnehmer geladen',
	'message.warning.privacy_protection.description': 'Sie befinden sich im Datenschutzmodus. Dies führt zu einer ' +
		'eingeschränkten Darstellung sensibler Daten und Informationen. Die Suche im oberen Tabellenbereich steht Ihnen weiterhin zur Verfügung.',
	'message.warning.privacy_protection.title': 'Erweiterter Datenschutz-Modus aktiv',
	'message.warning.project.noneLoaded.description':
		'Es wurde kein Projekt ausgewählt. Bitte wählen Sie ein solches über die Projektübersicht aus.',
	'message.warning.project.noneLoaded.title': 'Kein Projekt geladen',
	'message.warning.input.rangeLow': 'Der eingegebene Wert darf nicht unter {{rangeLow}}{{unit}} liegen',
	'message.warning.input.rangeHigh': 'Der eingegebene Wert darf nicht über {{rangeHigh}}{{unit}} liegen',
	'message.warning.input.invalid': 'Ungültige Eingabe',
	'message.warning.viewMode.notRecommended.title': 'Nicht Empfohlen',
	'message.warning.viewMode.notRecommended.description': 'Diese Ansicht wird für diesen Schritt nicht Empfohlen.',
	'message.warning.not_finished_sufficient':
		'Die Bearbeitung kann nicht abgeschlossen werden, da einige Fragen nicht beantwortet wurden.',
	'message.warning.devices_missing': 'Die folgenden Messgeräte fehlen, ' +
		'weshalb eine alternative Eingabe notwendig ist.',
	'message.warning.falseReactionInput': 'Die Eingabe wurde als Fehlversuch erkannt. Die Eingabe wird nicht gewertet.',
	'message.warning.sameUser': 'Gleicher Benutzer',
	'message.warning.sameUser_description': 'Ein Benutzer kann nicht seine eigenen Rollen bearbeiten.',
	'message.warning.noPermit': 'Keine Berechtigung',
	'message.warning.noPermit_description': 'Sie sind nicht berechtigt, auf dieser Seite Änderungen durchzuführen.',
	'message.warning.old_password.missing': 'Feld "Altes Password" ist leer.',
	'message.warning.password.missing': 'Feld "Neues Password" ist leer.',
	'message.warning.password_confirm.missing': 'Feld "Passwort bestätigen" ist leer.',
	'message.warning.password_not_match': 'Passwörter sind nicht gleich.',
	'message.warning.workflow.unstartedAndNoPermission': 'Dieser Schritt wurde noch nicht gestartet und Sie verfügen nicht über die Berechtigung, ihn zu starten.',
	'message.error.password.incorrect': 'Passwort ist falsch.',
	'message.error.delete.user': 'Benutzer konnte nicht gelöscht werden.',

	'misc.developer_settings': 'Entwicklereinstellungen',
	'misc.documentation': 'Dokumentation',
	'misc.forParticipants': 'Für {{ num }} Teilnehmer',
	'misc.hint': 'Hinweis',
	'misc.project': 'Projekt',
	'misc.projects': 'Projekte',
	'misc.privacy_policy': 'Datenschutzrichtlinie',
	'misc.primary_color': 'Primärfarbe setzen',
	'misc.settings': 'Einstellungen',
	'misc.switch_theme': 'Dunkles / Helles Theme umschalten',
	'misc.demo_mode': 'Demomodus',
	'misc.actualAgeLabel': 'Kalendarisches Alter ',
	'misc.bfaLabel': 'Ihr Biofunktionales Alter (BFA) ',
	'misc.actualAgeAbbreviation': ' Jahre',
	'misc.bfaAbbreviation': ' JÄ',
	'misc.referencePopulationLabel': 'Referenzpopulation Mitteleuropa',
	'misc.welcome': 'Willkommen auf der Gesundheitsplattform',

	'participants.add': 'Neuen Teilnehmer anlegen',
	'participants.cancel': 'Vorgang Abbrechen',
	'participants.create': 'Teilnehmer erstellen',
	'participant.data.key.address': 'Kontaktdaten',
	'participant.data.key.personal': 'Stammdaten',
	'participant.data.key.projects': 'Projekte',
	'participant.data.gender.male': 'männlich',
	'participant.data.gender.female': 'weiblich',
	'participant.data.gender.nonbinary': 'divers',
	'participant.delete.modal.text': 'Sind Sie sicher, dass sie den Teilnehmer {{ pid }} löschen möchten?',
	'participant.delete.modal.title': 'Teilnehmer {{ pid }} löschen',
	'participant.export': 'Exportieren',
	'participants.edit': 'Speichern',
	'participants.export': '{{ number }} Teilnehmer exportieren',
	'participants.toList': 'Details Verlassen',

	'projects.change_title': 'Aktives Projekt ändern',
	'projects.change_text': 'Sind Sie sicher, dass Sie das aktive Projekt ändern wollen? ' +
		'Der derzeitig ausgewählte Teilnehmer wird zurück gesetzt.',
	'projects.id': 'Projekt-ID',
	'projects.name': 'Projekt Name',
	'projects.server_id': 'Server-ID',
	'projects.add': 'Neues Projekt anlegen',
	'projects.create': 'Projekt erstellen',
	'projects.cancel': 'Vorgang abbrechen',
	'projects.doEdit': 'Änderungen speichern',
	'projects.uploadArchive': 'Projekt-Konfiguration aus Archiv hochladen',
	'projects.error.creationFailed': 'Projekt konnte nicht angelegt werden',
	'projects.error.editFailed': 'Projekt konnte nicht bearbeitet werden',
	'projects.error.archiveUploadFailed': 'Die Projekt-Konfiguration konnte nicht hochgeladen werden',

	'person.admin': 'Administrator',
	'person.analyst': 'Analytiker',
	'person.casemanager': 'Case-Manager',
	'person.doctor': 'Arzt',
	'person.expertier': 'Expertier',
	'person.participant': 'Teilnehmer',
	'person.participants': 'Teilnehmer',
	'person.therapist': 'Therapeut',
	'person.user': 'Benutzer',

	'workflow.abortSpecial': 'Abbrechen',
	'workflow.akustischeReaktion.started': 'Test läuft. Achten Sie auf den Ton und stoppen Sie, sobald Sie ihn hören.',
	'workflow.akustischeReaktion.ready': 'Test startbereit. Drücken Sie auf die Schaltfläche "Test Starten", um mit dem Test zu starten.',
	'workflow.optischeReaktion.ready': 'Test startbereit. Drücken Sie auf die Schaltfläche "Test Starten", um mit dem Test zu starten.',
	'workflow.beginSpecial': 'Beginnen',
	'workflow.cancel': 'Ansicht verlassen',
	'workflow.continue': 'Bearbeitung fortsetzen',
	'workflow.compactView': 'Kompaktansicht',
	'workflow.continueInCompact': 'im Kompaktmodus fortsetzen',
	'workflow.continueInWizard': 'im ablenkungsfreien Wizard fortsetzen',
	'workflow.distractionfreeWizard': 'Ablenkungsfreier Wizard',
	'workflow.end': 'Bearbeitung beenden',
	'workflow.endView': 'Ansicht beenden',
	'workflow.endWarning': 'Sind Sie sicher, dass Sie diesen Schritt abschließen möchten?',
	'workflow.examination': 'Auswertung',
	'workflow.execute': '{{ item }} durchführen',
	'workflow.hotWire.finished': 'Beendet',
	'workflow.hotWire.start': 'Bitte berühren Sie die grüne Zone um zu beginnen',
	'workflow.hotWire.started': '',
	'workflow.hoerverlust.started': 'Test läuft. Achten Sie auf den Ton und stoppen Sie, sobald Sie ihn hören bzw. nicht mehr hören.',
	'workflow.hoerverlust.ready': 'Test startbereit. Drücken Sie auf die Schaltfläche "Test Starten", um mit dem Test zu starten.',
	'workflow.hoerverlust.risingStop': 'Bitte stoppen Sie, wenn Sie den Ton hören.',
	'workflow.hoerverlust.fallingStop': 'Bitte stoppen Sie, wenn Sie den Ton nicht mehr hören.',
	'workflow.input.confirm': 'Eingabe bestätigt',
	'workflow.modal.finish.text': 'Sind Sie sicher, dass Sie die Bearbeitung beenden wollen?',
	'workflow.modal.finish.title': 'Ergebnisse bestätigen',
	'workflow.modal.reset.title': 'Zurücksetzen?',
	'workflow.modal.reset.text': 'Möchten sie den Schritt wirklich Zurücksetzen?',
	'workflow.modal.transition.bulk.titel': 'Multiple Prozessschritte durchführen',
	'workflow.modal.transition.bulk.text': 'Die Aktion wird für alle Prozessschritte der ausgewählten Teilnehmer durchgeführt, für die diese Aktion im Moment möglich ist.\n' +
		'Möchten Sie die {{ transitionAction }} (für {{ num }} Teilnehmer).',
	'workflow.reset': 'Zurücksetzen',
	'workflow.modal.missingdevices.title': 'Fehlende Hardware',
	'workflow.modal.missingdevices.text': 'Sie sehen die alternative Eingabe. Folgende Testgeräte werden benötigt, um den Test wie empfohlen durchzuführen:',
	'workflow.needsWizard': 'Dieser Test kann nur im Vollbildmodus ausgeführt werden. ' +
		'Bitte wechseln Sie in den ablenkungsfreien Wizard.',
	'workflow.nextPage': 'Nächste Seite',
	'workflow.openManualInput': 'Alternative Eingabe',
	'workflow.openManualInputCompact': 'Alternative Eingabe öffnen',
	'workflow.closeManualInputCompact': 'Alternative Eingabe schließen',
	'workflow.editManualInputValuesCompact': 'Werte bearbeiten',
	'workflow.modal.missing_value.title': 'Altersklassen-Mittelwerte anwenden',
	'workflow.modal.missing_value.text': 'Sind Sie sicher, dass Sie für diesen Abschnitt die hinterlegten Altersklassen-Mittelwerte anwenden möchten?',
	'workflow.missing_value_epilog': 'Es werden Altersklassen-Mittelwerte angewandt.',
	'workflow.missing_value_in_use': 'Es werden Altersklassen-Mittelwerte angewandt.',
	'workflow.newOpenManualInput': 'Neue alternative Eingabe',
	'workflow.next_labyrinth': 'Nächstes Labyrinth',
	'workflow.noDevices': 'Dieser Test kann nur im Vollbildmodus ausgeführt werden und besitzt zudem spezifische Hardwareanforderungen, ' +
		'die Ihr System nicht erfüllt. Es wird empfohlen den Test auf einem anderen System durchzuführen.',
	'workflow.overview': 'Übersicht',
	'workflow.previousPage': 'Vorherige Seite',
	'workflow.quitOverview': 'Übersicht verlassen',
	'workflow.quitWizard': 'Wizard verlassen',
	'workflow.randomization': 'Randomisierung',
	'workflow.randomization.allocated': 'Die Randomisierung wurde abgeschlossen. Der Teilnehmer wurde der Gruppe "{{group}}" zugeordnet.',
	'workflow.randomization.pending': 'Nach der Ausführung der Randomisierung wird der Teilnehmer zufällig der Kontroll- oder Interventionsgruppe zugeordnet. ' +
		'Diese Zuordnung kann anschließend nicht rückgängig gemacht werden.',
	'workflow.resetData': 'Eingaben zurücksetzen',
	'workflow.resetMessage.warning': 'Sind Sie sicher, dass sie alle Daten dieses Schritts zurücksetzen möchten?',
	'workflow.resetReport': 'Auswertungen neu berechnen',
	'workflow.restartSpecial': 'Neu Starten',
	'workflow.show': 'Anzeigen',
	'workflow.showInCompact': 'im Kompaktmodus anzeigen',
	'workflow.showInWizard': 'im ablenkungsfreien Wizard anzeigen',
	'workflow.show_Overview': 'Übersicht anzeigen',
	'workflow.show_OverviewInCompact': 'Übersicht im Kompaktmodus anzeigen',
	'workflow.show_OverviewInWizard': 'Übersicht im ablenkungsfreien Wizard anzeigen',
	'workflow.start': 'Bearbeitung beginnen',
	'workflow.startInCompact': 'im Kompaktmodus starten',
	'workflow.startInWizard': 'im ablenkungsfreien Wizard starten',
	'workflow.test.completed': 'Der Test wurde abgeschlossen.',
	'workflow.test.result.number': 'Testergebnis {{num}}',
	'workflow.test.result.measurement': 'Messung {{num}}',
	'workflow.test.started': 'Test im Gange',
	'workflow.test.colorWord.TextOnly': 'Bitte lesen Sie die Wörter.',
	'workflow.test.colorWord.ColorOnly': 'Bitte benennen Sie die Farben.',
	'workflow.test.colorWord.ColorText': 'Bitte benennen Sie die Schriftfarbe.',
	'workflow.test.colorWord.verbalReaction': 'Verbale Reaktionsfähigkeit',
	'workflow.test.colorWord.cognitiveReaction': 'Kognitive Reaktionsfähigkeit',
	'workflow.test.colorWord.cognitiveAdaptability': 'Kognitive Umstellfähigkeit',
	'workflow.test.colorWord.redGreenBlind': 'Rot-Grün-Sehschwäche vorhanden',
	'workflow.test.digitalHearingLoss.averageByInput': 'Mittelwerte laut Eingabe',
	'workflow.test.digitalHearingLoss.averageByCompute': 'Berechnete Mittelwerte',
	'workflow.test.labyrinth.labyrinth': '{{num}} Labyrinth',
	'workflow.test.labyrinth.repetitiveErrors': 'Wiederholungsfehler',
	'workflow.test.labyrinth.trialMistake': 'Probefehler',
	'workflow.test.tapping.cycle': 'Anschläge Testzyklus {{num}}',
	'workflow.wait.input': 'Warte auf Eingabe',
	'workflow.wizardOpen': 'Im Wizard öffnen',

	'result.correct': 'Richtig: ',
	'result.error': 'Fehlerquote: ',
	'result.time': 'Zeit: ',
	'result.value': 'Wert',

	'search.no_results': 'Keine Ergebnisse gefunden',
	'search.search_results': 'Suchergebnisse',
	'search.too_many_results': 'Zu viele Suchergebnisse',
	'search.too_many_results_more': 'Bitte grenzen Sie die Suche ein',
	'search.use_extended_search': 'Erweiterte Suche',

	'status.finished': 'Abgeschlossen',
	'status.locked': 'Nicht verfügbar',
	'status.started': 'In Bearbeitung',
	'status.unstarted': 'Nicht begonnen',
	'status.queries.open': 'Offene Query',
	'status.queries.responded': 'Bearbeitete Query',

	'ui.showcase.primary': 'Primär',
	'ui.showcase.secondary': 'Sekundär',
	'ui.showcase.delete': 'Löschen',
	'ui.showcase.pureButton': 'Nur Buttons',
	'ui.showcase.buttonIcon': 'Buttons mit Icon',
	'ui.showcase.splitbuttonIcon': 'Splitbuttons mit Icon',
	'ui.showcase.splitbuttonCallback': 'Splitbuttons mit Callback und Divider',
	'ui.showcase.pureIcons': 'Nur Icons',
	'ui.showcase.distractionFreeButtons': 'Ablenkungsfreier Wizard Buttons',

	'unit.milliseconds.short': 'msek',
	'unit.seconds.short': 'sek',

	'user.add': 'Neuen Benutzer anlegen',
	'user.createdDate': 'Erstelldatum',
	'user.data': 'Benutzerdaten',
	'user.roles': 'Benutzerrollen',
	'user.email_long': 'E-Mail-Adresse',
	'user.email_short': 'E-Mail',
	'user.firstname': 'Vorname',
	'user.surname': 'Nachname',
	'user.birthday': 'Geburtstag',
	'user.uid': 'Teilnehmer-ID',
	'user.username': 'Benutzername',
	'user.name': 'Name',
	'user.password': 'Passwort',
	'user.oldPassword': 'altes Passwort',
	'user.newPassword': 'neues Passwort',
	'user.password_confirm': 'Passwort bestätigen',
	'user.projectsAndRoles': 'Projekt- und Rollenzuordnung',
	'user.delete.modal.text': 'Sind Sie sicher, dass sie den User {{ username }} löschen möchten?',
	'user.delete.modal.title': 'User {{ username }} löschen',
	'user.editroles.title': '{{ username }} - Projekt- und Rollenzuordnung',
	'user.editroles.roles': 'Benutzerrollen',
	'user.editroles.groups': 'Benutzergruppen',

	'word.ageIndex': 'Altersindex',
	'word.description': 'Beschreibung',
	'word.icon': 'Icon',
	'word.iconName': 'Icon Name',
	'word.meaning': 'Bedeutung',
	'word.measurement': 'Messung',
	'word.num.first': 'Erstes',
	'word.num.second': 'Zweites',
	'word.num.third': 'Drittes',
	'word.participant.singular': 'Teilnehmer',
	'word.participant.plural': 'Teilnehmer',
	'word.profit.forprofit': 'Kommerziell',
	'word.profit.nonprofit': 'Nicht-Kommerziell',
	'word.set': 'Set',
	'word.left': 'Links',
	'word.leftEar': 'Linkes Ohr',
	'word.right': 'Rechts',
	'word.rightEar': 'Rechtes Ohr',
	'word.both': 'Beide',
	'word.time': 'Zeit',
	'word.error': 'Fehler',
	'word.missing_value': 'Altersklassen-Mittelwert',
	'word.missing_value_remove': 'Altersklassen-Mittelwert entfernen',
	'word.missing_value_remove_with_title': 'Altersklassen-Mittelwert für "{{missing_value}}" entfernen',
	'word.missing_value_use': 'Altersklassen-Mittelwert anwenden',
	'word.missing_value_use_with_title': 'Altersklassen-Mittelwert für "{{missing_value}}" anwenden',
	'word.years': 'Jahre',
	'word.workflow-item': 'Prozessschritt',

	'login-dialog.login': 'Bestätigen',
	
	'generic.confirm.title': 'Bestätigen?',
	'generic.confirm.yes': 'Ja',
	'generic.confirm.no': 'Nein',
	
	'protocol.title': 'Protokoll',
	
	'timeline.workflow-item-unknown': 'einen Prozessschritt',
	'timeline.participant-unknown': 'einen Teilnehmer',
	'timeline.participant-create': '{{ username }} hat {{ participant }} angelegt',
	'timeline.participant-update': '{{ username }} hat {{ participant }} bearbeitet',
	'timeline.participant-delete': '{{ username }} hat {{ participant }} gelöscht',
	'timeline.workflow-item-inprogress': '{{ username }} hat {{ workflowItem }} für {{ participant }} bearbeitet',
	'timeline.workflow-item-completed': '{{ username }} hat {{ workflowItem }} für {{ participant }} abgeschlossen',
	'timeline.workflow-item-inprogress-reset': '{{ username }} hat {{ workflowItem }} für {{ participant }} zurückgesetzt',
	'timeline.workflow-item-completed-reset': '{{ username }} hat {{ workflowItem }} für {{ participant }} zurückgesetzt',
	'timeline.config-archive-upload': '{{ username }} hat ein neues Projektarchiv hochgeladen',
	'timeline.custom-state-change': '{{ username }} hat den Status von {{ workflowItem }} für {{ participant }} geändert',
	
	'query.card.title': 'Rückfragen (Query)',
	'query.create.title': 'Erstellen',
	'query.create.question.label': 'zu Frage',
	'query.create.question.placeholder': 'Keine Frage ausgewählt',
	'query.create.query': 'Nachricht',
	'query.create.button': 'Abschicken',
	'query.edit.opened': 'Offene',
	'query.edit.responded': 'Beantwortete',
	'query.edit.comment': 'Nachricht',
	'query.edit.button.respond': 'Antworten',
	'query.edit.button.comment': 'Kommentieren',
	'query.edit.button.close': 'Abschließen',
	'query.empty': 'Keine Rückfragen offen',
	
	'profile.title': 'Mein Profil',
	'profile.password.error.title': 'Passwort stimmt nicht überein',
	'profile.password.error.description': '',
	'profile.password.invalid.error.title': 'Passwort ist nicht gültig',
	'profile.password.invalid.error.description': '',
	'profile.password.success.title': 'Passwort wurde geändert',
	'profile.password.success.description': '',	
	'profile.unknown.error.title': 'Fehler beim Speichern',
	'profile.unknown.error.description': '',
	'profile.save.success.title': 'Profil erfolgreich gespeichert',
	'profile.save.success.description': '',
};
